const favouriteOwnAdInfo = {
    yes: 'Y',
    no: 'N',
    saveAdOwnerComment(adId, userId, saveComment) {
        let adOwnerComment =
            saveComment === this.yes ? $(`#ownerComment_${userId}`).val() : $(`#updatedComment_${userId}`).text();
        let userContacted = $(`#userContected_${userId}`).is(':checked') ? this.yes : this.no;

        if (userId && adId) {
            let csrfToken = $('#favourite_by_details input[name="token"]').val() || '';
            let payload = {
                userId,
                adId,
                userContacted,
                adOwnerComment,
                token: csrfToken,
            };
            $.post(Routing.generate('update_own_ad_favourite_info'), payload, function (response) {
                if (response.status === 'error' && response.message) {
                    alert(response.message);
                    return;
                }

                if (saveComment === favouriteOwnAdInfo.yes) {
                    if (adOwnerComment) {
                        $(`#addComment_${userId}`).hide();
                        $(`#adOwnerComment_${userId}`).show();
                    }
                    $(`#updatedComment_${userId}`).text(adOwnerComment);
                    $(`#saveButton_${userId}`).hide();
                }
                window.$.colorbox.resize({ width: $('#colorbox').width() });
            });
        }
    },
    editComment(userId) {
        let oldComment = $(`#updatedComment_${userId}`).text().trim();
        $(`#saveButton_${userId}`).show();
        $(`#adOwnerComment_${userId}`).hide();
        $(`#addComment_${userId}`).show();
        $(`#ownerComment_${userId}`).val(oldComment);
        window.$.colorbox.resize({ width: $('#colorbox').width() });
    },
    cancelAddComment(userId) {
        $(`#saveButton_${userId}`).hide();
        let oldComment = $(`#updatedComment_${userId}`).text();

        if (oldComment) {
            $(`#addComment_${userId}`).hide();
            $(`#adOwnerComment_${userId}`).show();
        }
        window.$.colorbox.resize({ width: $('#colorbox').width() });
    },
};

$(function () {
    let $body = $('body');

    // edit comment
    $body.on('click', '.editComment', function () {
        favouriteOwnAdInfo.editComment($(this).data('user-id'));
    });

    // click event for cancel button for save/edit comment
    $body.on('click', '.cancelAddComment', function () {
        favouriteOwnAdInfo.cancelAddComment($(this).data('user-id'));
    });

    // add new comment
    $body.on('click', '.saveAdOwnerComment', function () {
        favouriteOwnAdInfo.saveAdOwnerComment(
            $('.favouriteAdId').val(),
            $(this).data('user-id'),
            $(this).data('save-comment')
        );
    });
});
